var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymptomVomiting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 114,
    viewBox: "0 0 119 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47716 4.47715 0 10 0H109C114.523 0 119 4.47715 119 10V114H0V10Z",
    fill: "#77E1FD",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62C89 79.6733 74.6733 94 57 94C39.3267 94 25 79.6733 25 62C25 44.3267 39.3267 30 57 30C74.6733 30 89 44.3267 89 62Z",
    fill: "#77E1FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4443 61.7539V67.4827H45.7437C41.0114 70.7662 38.5351 76.3742 39.3247 82.0203L41 93.9996H25V86.0938C25 74.2812 33.4523 64.1031 45.2126 61.754L52.4443 61.7539Z",
    fill: "#2FDDD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9062 82.8945H35.6562V86.5859H31.9062V82.8945Z",
    fill: "#199A8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9062 75.4814H34.6562V79.1729H30.9062V75.4814Z",
    fill: "#199A8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.579 72.6959L63.7715 78.4213H58.014L57.2677 70.374L49.2165 71.7349C47.7765 71.9773 46.4065 71.036 46.1427 69.6222L45.744 67.4824L50.5327 64.1602L50.5215 63.9215L45.2127 61.7534V59.5558L42.5427 56.9275L47.8827 48.1715V41.1603L63.7715 40.0578L67.1302 39.8252L73.1052 62.1656C72.6327 63.3087 72.519 64.5822 72.834 65.8201L74.579 72.6959Z",
    fill: "#FFC7B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.579 72.6959L63.7715 78.4213V40.0578L67.1302 39.8252L73.1052 62.1656C72.6327 63.3087 72.519 64.5822 72.834 65.8201L74.579 72.6959Z",
    fill: "#FAB096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9184 47.444V47.4538C79.9184 52.2637 77.9347 56.8152 74.5059 60.1141C73.8909 60.706 73.4197 61.4073 73.1047 62.1665L68.2759 55.618C71.0922 52.3056 67.9784 47.4218 63.7709 48.3767L61.2309 48.955V45.4346C61.2309 43.0746 59.2872 41.1612 56.8884 41.1612H47.8822C46.1722 39.4779 45.2122 37.1966 45.2122 34.8169V31H63.2134C63.3997 31 63.5859 31.0025 63.7709 31.0098C72.7384 31.2978 79.9184 38.5452 79.9184 47.444Z",
    fill: "#42789D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.919 47.4439V47.4538C79.919 52.2637 77.9352 56.8152 74.5065 60.114C73.8915 60.7059 73.4202 61.4073 73.1052 62.1665L68.2765 55.6179C71.0927 52.3055 67.979 47.4218 63.7715 48.3766V31.0098C72.739 31.2977 79.919 38.5452 79.919 47.4439Z",
    fill: "#335A8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0001 93.9994H52.9951L58.0139 78.4217L63.7714 76.432L74.5789 72.6963C83.4339 76.1871 89.0051 84.8299 89.0001 93.9994Z",
    fill: "#FF69AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0002 93.9994H63.7715V76.432L74.579 72.6963C83.434 76.1871 89.0052 84.8299 89.0002 93.9994Z",
    fill: "#DE5B95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 31,
    width: 64,
    height: 63,
    rx: 31.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomVomiting);
export default __webpack_public_path__ + "static/media/symptom-Vomiting.2e684109268bb5a27c4aea985155ab79.svg";
export { ForwardRef as ReactComponent };